import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ElMessage } from 'element-plus';
import { OAuthController } from '@/api/system/index';

import { ref, computed, onMounted } from 'vue';
export default /*#__PURE__*/_defineComponent({
  ...{
    name: 'FeishuLogin'
  },
  __name: 'login',
  props: {
    bindSocial: {
      type: Boolean,
      default: false
    },
    dialog: {}
  },
  emits: ['success', 'error'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const isWeComLogin = ref(false);
    const weComLoginClass = computed(() => {
      return isWeComLogin.value ? 'we_com_login' : '';
    });
    onMounted(() => {
      // 初始化登录组件
      const wwLogin = window.ww.createWWLoginPanel({
        el: '#login_qrcode_container',
        params: {
          login_type: 'CorpApp',
          appid: process.env.VUE_APP_WEWORK_CORP_ID,
          agentid: process.env.VUE_APP_WEWORK_AGENT_ID,
          redirect_uri: process.env.VUE_APP_WEWORK_REDIRECT_URI,
          state: 'loginState',
          redirect_type: 'callback'
        },
        onCheckWeComLogin: res => {
          console.log('企业微信客户端在线', res);
          isWeComLogin.value = res.isWeComLogin;
        },
        onLoginSuccess: res => {
          console.log('企业微信登录成功', res);
          if (props.bindSocial) {
            OAuthController.bind({
              source: 'wework',
              code: res.code
            }).then(res => {
              console.log('企业微信绑定成功', res);
              if (props.dialog) {
                ElMessage.success('绑定成功');
                props.dialog.submit(res);
              }
              emit('success', res);
            }).catch(e => {
              emit('error', e);
            });
          } else {
            OAuthController.login({
              source: 'wework',
              code: res.code
            }).then(res => {
              console.log('企业微信登录成功', res);
              if (props.dialog) {
                props.dialog.submit(res);
              }
              emit('success', res);
            }).catch(e => {
              console.warn('企业微信登录失败', e);
              emit('error', e);
            });
          }
        },
        onLoginFail: err => {
          console.log('企业微信登录失败', err);
          emit('error', err);
        },
        onOpenInWecom(res) {
          console.log('在企业微信中打开了', res);
        }
      });
      if (wwLogin) {
        wwLogin.el.style.width = '100%';
        wwLogin.el.style.height = '380px';
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        id: "login_qrcode_container",
        class: _normalizeClass(_unref(weComLoginClass))
      }, null, 2);
    };
  }
});